import React from "react";
import {
    Avatar,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import Box from "@mui/material/Box";
import CreateIcon from '@mui/icons-material/Create';
import {useNavigate} from "react-router";
import {useParams} from "react-router-dom";
import {addWhiteShade} from "../../services/utills";
import {scrollCSS} from "../../App";

// Helper function to create date without timezone issues
const createDate = (date) => {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
};

// Helper function to compare dates without timezone issues
const isSameUTCDate = (date1, date2) => {
    if (!date1 || !date2) return false;
    return date1.getUTCFullYear() === date2.getUTCFullYear() &&
        date1.getUTCMonth() === date2.getUTCMonth() &&
        date1.getUTCDate() === date2.getUTCDate();
};

function WeekView({data = [], day, setStaffData}) {
    const startDate = createDate(day);
    const finalDays = [];
    const headerCells = [];
    const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const navigate = useNavigate();
    const params = useParams();
    const defaultColor = "#f2f2f2";

    // Process each staff member
    for (let j = 0; j < data.length; j++) {
        let days = [];
        const staff = data[j]?.staff || {};
        const staffSlots = data[j]?.slots || [];

        // Create cells for each day of the week
        for (let i = 0; i < 7; i++) {
            const date = new Date(startDate);
            date.setUTCDate(startDate.getUTCDate() + i);

            // Find matching slot using UTC comparison
            const cellData = staffSlots.find(item => {
                try {
                    const itemDate = new Date(item?.date);
                    return isSameUTCDate(itemDate, date);
                } catch (e) {
                    return false;
                }
            });

            const modifiedColor = staff?.color ? addWhiteShade(staff?.color) : defaultColor;

            if (cellData?.slots?.length) {
                days.push(
                    <TableCell key={i} sx={{p: '10px'}}>
                        <Box sx={{
                            minHeight: '120px',
                            width: '170px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            borderRadius: '7px',
                            padding: '10px',
                            backgroundColor: modifiedColor,
                            color: staff?.color
                        }}>
                            <Box>
                                <Typography sx={{fontWeight: "bold"}}>{staff?.name}</Typography>
                                <Typography>{cellData?.checkin} - {cellData?.checkout}</Typography>
                            </Box>
                            <Box sx={{display: 'flex'}}>
                                <Box sx={{
                                    backgroundColor: '#fff',
                                    width: '45%',
                                    borderRadius: '10px',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer'
                                }} onClick={() => setStaffData(staff)}>
                                    <CreateIcon sx={{fontSize: '11px'}}/>
                                    <Box sx={{fontSize: '11px', ml: "7px"}}>edit</Box>
                                </Box>
                            </Box>
                        </Box>
                    </TableCell>
                );
            } else {
                days.push(
                    <TableCell key={i} sx={{p: '10px'}}>
                        <Box sx={{ minHeight: '120px', width: '170px' }}></Box>
                    </TableCell>
                );
            }

            // At end of week, add staff info and push to finalDays
            if (i === 6) {
                days.unshift(
                    <TableCell key="staff-info">
                        <Box sx={{display: 'flex', alignItems: 'center', pl: '4px'}}>
                            <Avatar alt={staff?.name} sx={{borderRadius: '7px'}} src={staff?.profile_image} />
                            <Typography sx={{ml: "10px"}}>{staff?.name}</Typography>
                        </Box>
                    </TableCell>
                );
                finalDays.push({days});
            }
        }
    }

    // Create header cells with proper UTC dates
    for (let i = 0; i < 7; i++) {
        const date = new Date(startDate);
        date.setUTCDate(startDate.getUTCDate() + i);

        headerCells.push(
            <TableCell sx={{px: '6px'}} key={i}>
                <Box sx={{display: 'inline-block', mr: '4px', fontSize: '18px'}}>
                    {weekDays[date.getUTCDay()]}
                </Box>
                <Box sx={{display: 'inline-block', mr: '4px', fontSize: '18px'}}>
                    {date.getUTCDate()}
                </Box>
            </TableCell>
        );
    }

    return (
        <TableContainer component={Paper} sx={{
            boxShadow: 'none',
            ...scrollCSS,
            paddingBottom: '5px',
            "&::-webkit-scrollbar": { height: "5px" }
        }}>
            <Table sx={{
                boxShadow: 'none',
                "td, th": { border: "1px solid #E0E0E0" }
            }}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{background: '#fff', width: '150px'}}>
                            <Typography sx={{textAlign: 'center', fontSize: '18px'}}>Staff Name</Typography>
                        </TableCell>
                        {headerCells}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {finalDays.map((item, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {item.days}
                        </TableRow>
                    ))}
                    <TableRow>
                        <TableCell sx={{background: '#fff'}}>
                            <Box
                                sx={{color: '#2F80ED', cursor: 'pointer'}}
                                onClick={() => navigate(`/crm/configuration/clinic/${params?.clinic_id}/add-staff`)}
                            >
                                + Add Employee
                            </Box>
                        </TableCell>
                        {Array(7).fill().map((_, i) => (
                            <TableCell key={`empty-${i}`} sx={{background: '#fff'}} />
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default WeekView;